import React from "react"
import clsx from "clsx"

export const StyledParagraph: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = ({ className, children, ...rest }) => {
  return (
    <p className={clsx("ant-typography", "ant-typography-paragraph", className)} {...rest}>
      {children}
    </p>
  )
}
